module.exports = __webpack_public_path__ + "assets/img/14_1002_big.04f38b90.jpg";